(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/drawselector/assets/javascripts/views/drawselector-list.js') >= 0) return;  svs.modules.push('/components/sport/drawselector/assets/javascripts/views/drawselector-list.js'); 'use strict';

var DrawselectorList = Backbone.Marionette.View.extend({
  collection: svs.sport.drawselector.collections.DrawselectorList,
  events: {
    'click .js-change-round': 'changeRound'
  },
  template: function template(data) {
    return svs.sport.drawselector.templates.drawselector_list(data);
  },
  changeRound: function changeRound(ev) {
    this.triggerMethod('changeRound', $(ev.currentTarget).data('drawnum'));
  }
});
setGlobal('svs.sport.drawselector.views.DrawselectorList', DrawselectorList);
 })(window);